module.exports = __webpack_public_path__ + "7e655da462dadb24944b3fb4cb978ef7.svg";